import { useState, useEffect, useRef } from 'react';
import { HelpCircle, Compass, FileDown } from 'lucide-react';

export default function HelpMenu({ onStartTour }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative" data-tour="ayuda">
      <button onClick={() => setOpen(!open)} className="p-2 text-[#888] hover:text-[#F8F6F0] transition-colors">
        <HelpCircle className="w-5 h-5" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-60 bg-[#0E0E0E] border border-[rgba(201,164,76,0.2)] rounded-xl shadow-2xl z-50 overflow-hidden">
          <div className="px-4 py-3 border-b border-white/5">
            <span className="text-sm font-medium">Ayuda</span>
          </div>
          <button onClick={() => { setOpen(false); onStartTour?.(); }}
            className="w-full text-left flex items-center gap-2.5 px-4 py-3 text-sm text-[#A0A0A0] hover:text-[#F8F6F0] hover:bg-white/[0.04] transition-all border-b border-white/[0.03]">
            <Compass className="w-4 h-4 text-[#C9A44C]" /> Ver guía interactiva
          </button>
          <a href="/manual-lexorbit.pdf" target="_blank" rel="noopener noreferrer" download
            className="w-full text-left flex items-center gap-2.5 px-4 py-3 text-sm text-[#A0A0A0] hover:text-[#F8F6F0] hover:bg-white/[0.04] transition-all">
            <FileDown className="w-4 h-4 text-[#C9A44C]" /> Manual de usuario (PDF)
          </a>
        </div>
      )}
    </div>
  );
}
